/**
 * Reads that do NOT go through /profile/getResult.
 *
 * getResult executes SQL from the request body. Even with the statement guard in
 * front of it, every call site that builds `CALL sp_x('${value}')` in the browser
 * is putting user input into a SQL string. These go to /data instead, where the
 * procedure name is checked against an allow-list and the arguments are bound.
 *
 * Migrate a call site by replacing:
 *     profileService.getResult({ qry: `CALL sp_x('${a}', ${b})` })   // -> [[rows]]
 * with:
 *     callProc('sp_x', [a, b])                                       // -> rows
 *
 * Note the return shape is already unwrapped — no more `res?.[0]` guessing,
 * which is the mistake this codebase keeps making (CALL yields [[rows], okPacket]
 * while a plain SELECT yields [rows]).
 */
const API = process.env.REACT_APP_API_END_POINT || 'https://gsapi.geetsuhane.com';

async function asJson(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || `Request failed (${response.status})`);
  return body;
}

/** Call an allow-listed read procedure. Returns the rows, or [] on failure. */
export async function callProc(proc, args = []) {
  try {
    const body = await fetch(`${API}/data/call`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ proc, args }),
    }).then(asJson);
    return Array.isArray(body.rows) ? body.rows : [];
  } catch (e) {
    console.error(`callProc ${proc}:`, e.message);
    return [];
  }
}

/** The home page's latest-posts widget — bots and retired posts already excluded. */
export async function latestPosts() {
  try {
    const body = await fetch(`${API}/data/latest-posts`).then(asJson);
    return Array.isArray(body.rows) ? body.rows : [];
  } catch (e) {
    console.error('latestPosts:', e.message);
    return [];
  }
}

export default { callProc, latestPosts };
